function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDiploma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "m28 32.002a2.6668 2.6668 0 0 1 0 5.3337h-8.0005a2.6668 2.6668 0 0 1 0-5.3337zm16.001-8.0005a2.6668 2.6668 0 0 0-2.6668-2.6668h-21.335a2.6668 2.6668 0 0 0 0 5.3337h21.335a2.6668 2.6668 0 0 0 2.6668-2.6668zm-24.002-8.0005h21.335a2.6668 2.6668 0 0 0 0-5.3337h-21.335a2.6668 2.6668 0 0 0 0 5.3337zm32.002 35.853v10.222a1.9228 1.9228 0 0 1-3.2829 1.3601l-2.0508-2.0481-2.0508 2.0481a1.9228 1.9228 0 0 1-3.2829-1.3601v-10.222a10.633 10.633 0 0 1 5.3337-19.852 10.505 10.505 0 0 1 2.6668 0.37869v-19.047a8.0005 8.0005 0 0 0-8.0005-8.0005h-21.335a8.0005 8.0005 0 0 0-8.0006 8.0005v32.002a8.0005 8.0005 0 0 0 8.0006 8.0005h13.334a2.6668 2.6668 0 0 1 0 5.3337h-13.334a13.35 13.35 0 0 1-13.334-13.334v-32.002a13.35 13.35 0 0 1 13.334-13.334h21.335a13.35 13.35 0 0 1 13.334 13.334v22.354a10.534 10.534 0 0 1-2.6668 16.166zm0-9.1846a5.3337 5.3337 0 1 0-5.3337 5.3337 5.3337 5.3337 0 0 0 5.3337-5.3337z",
    style: {
      strokeWidth: 2.6668
    },
    fill: "currentColor"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiploma);
export default __webpack_public_path__ + "static/media/diploma.f33ec4fb.svg";
export { ForwardRef as ReactComponent };